import React from "react";
import withIntl from "../../utils/withIntl";
import { Close } from "@material-ui/icons";
import { DialogContent, DialogTitle } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { useDialog } from "../Dialogs/DialogProvider";
import { updateArrangement } from "../../store/ArrangementApi";
import AmountButtonSettings from "./AmountButtonSettings";
import CategoriesSetting from "./CategoriesSetting";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import MaxPriceSetting from "./MaxPriceSetting";
import TextFieldForms from "../Forms/TextFieldForms";
import RoundCategoriesSetting from "./RoundCategoriesSetting";

let newSetting = { buttons: [], initial_max: 10 };
let newSettingTime = { buttons: [], initial_max: 180 };

function ArrangementSettingsDialog(props) {
  const [arrangementSettings, setArrangementSettings] = React.useState({
    ordergroup_limit: props.arrangement.ordergroup_limit ?? null,
    time_limit: props.arrangement.time_limit ?? null,
    categories: props.arrangement.categories ?? null,
    round_categories: props.arrangement.round_categories ?? null,
    max_amount_concept: props.arrangement.max_amount_concept ?? null,
  });
  const [, closeDialog] = useDialog();

  const updateButtons = (newButton, setting, removed) => {
    const buttons = [...arrangementSettings[setting].buttons];
    const index = arrangementSettings[setting].buttons
      .map((button) => button.m_article_id)
      .indexOf(newButton.m_article_id);
    if (removed) {
      buttons.splice(index, 1);
    } else {
      if (index === -1) {
        buttons.push(newButton);
      } else {
        buttons.splice(index, 1, newButton);
      }
    }
    const newArrangementSettings = {
      ...arrangementSettings,
      [setting]: {
        ...arrangementSettings[setting],
        buttons: buttons,
      },
    };
    setArrangementSettings(newArrangementSettings);
  };

  return (
    <>
      <DialogTitle id="form-dialog-title">
        <div>
          <Typography>{props.intl.formatMessage({ id: "arrangement_settings" })}</Typography>
          <Typography variant={"h5"}>{props.article.name}</Typography>
        </div>
        <IconButton
          onClick={() => {
            closeDialog();
          }}
          color="primary"
          style={{ position: "absolute", top: "8px", right: "8px" }}
        >
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              closeDialog();
              updateArrangement(props.spMerchantId, props.arrangement, arrangementSettings);
            }}
          >
            <TextFieldForms
              type={"number"}
              label={"Number of seconds between AYCE orders"}
              value={arrangementSettings.time_limit?.time_interval ?? props.spMerchant.sp_ayce_setting.time_interval}
              onChange={(event) => {
                let newArrangementSettings = { ...arrangementSettings };

                if (!newArrangementSettings.time_limit) {
                  newArrangementSettings.time_limit = {};
                }
                if (!newArrangementSettings.time_limit.buttons) {
                  newArrangementSettings.time_limit = { buttons: [] };
                }
                if (isNaN(event.target.value)) {
                  delete newArrangementSettings.time_limit.time_interval;
                } else {
                  newArrangementSettings.time_limit.time_interval = parseInt(event.target.value);
                }
                setArrangementSettings(newArrangementSettings);
              }}
            />
            <AmountButtonSettings
              setting={arrangementSettings.ordergroup_limit}
              type={"ordergroup_limit"}
              label={"Enter maximal number of rounds"}
              onChangeFields={(value) => {
                let newArrangementSettings = { ...arrangementSettings, ordergroup_limit: value };
                setArrangementSettings(newArrangementSettings);
              }}
              updateButtons={(newButton, removed) => {
                updateButtons(newButton, "ordergroup_limit", removed);
              }}
            />
            <AmountButtonSettings
              setting={arrangementSettings.time_limit}
              type={"time_limit"}
              label={"Enter maximal minutes for receipt"}
              updateButtons={(newButton, removed) => {
                updateButtons(newButton, "time_limit", removed);
              }}
              onChangeFields={(value) => {
                let newArrangementSettings = { ...arrangementSettings, time_limit: value };
                setArrangementSettings(newArrangementSettings);
              }}
            />
            <CategoriesSetting
              setting={arrangementSettings.categories}
              onChangeFields={(value) => {
                let newArrangementSettings = { ...arrangementSettings, categories: value };
                setArrangementSettings(newArrangementSettings);
              }}
              updateCategories={(category, removed) => {
                let key = Object.keys(category)[0];
                let newArrangementSettings = {
                  ...arrangementSettings,
                  categories: { ...arrangementSettings.categories },
                };
                if (removed) {
                  delete newArrangementSettings.categories[key];
                } else {
                  newArrangementSettings.categories[key] = category[key];
                }
                setArrangementSettings(newArrangementSettings);
              }}
            />
            <RoundCategoriesSetting
              setting={arrangementSettings.round_categories}
              onChangeFields={(value) => {
                let newArrangementSettings = { ...arrangementSettings, round_categories: value };
                setArrangementSettings(newArrangementSettings);
              }}
              updateCategories={(category, removed) => {
                let key = Object.keys(category)[0];
                let newArrangementSettings = {
                  ...arrangementSettings,
                  round_categories: { ...arrangementSettings.round_categories },
                };
                if (removed) {
                  delete newArrangementSettings.round_categories[key];
                } else {
                  newArrangementSettings.round_categories[key] = category[key];
                }
                setArrangementSettings(newArrangementSettings);
              }}
            />
            <MaxPriceSetting
              onChange={(price) => {
                let newArrangementSettings = { ...arrangementSettings };
                if (price.length === 0) {
                  newArrangementSettings.max_amount_concept = null;
                } else {
                  let cents = Math.round(price * 100);
                  newArrangementSettings.max_amount_concept = { plus: { [props.article.plu]: { price: cents } } };
                }
                setArrangementSettings(newArrangementSettings);
              }}
              price={
                props.article && isNaN(arrangementSettings.max_amount_concept?.plus[props.article.plu].price)
                  ? ""
                  : arrangementSettings.max_amount_concept.plus[props.article.plu].price / 100.0
              }
              article={props.article}
            />
            <div style={{ height: 50 }}>
              <Divider style={{ marginTop: "8px", marginBottom: "8px" }} />
              <Button type="submit" style={{ margin: 5, float: "right" }}>
                {props.intl.formatMessage({ id: "save_settings" })}
              </Button>
            </div>
          </form>
        </div>
      </DialogContent>
    </>
  );
}

export default withIntl(ArrangementSettingsDialog);
